export const definiciones = Object.freeze({
URL_API: "https://icontae.com/webadmin/api",
//URL_API: "https://informaticacontable.com/icadmin/api",
//URL_API: "http://icontaew.test/api",
//  URL_WEB: "https://informaticacontable.com/ic",
URL_WEB: "https://icontae.com/web",
//URL_WEB: "http://icontaew.test",

});

function getAccess(seccion, actions, bloqueos){
  let key = seccion.concat("_", actions);
  if (bloqueos.length==0){
    return true;
  } else {
    return bloqueos.indexOf(key)>-1 ? false : true; //--- en ves de permisos, son bloqueos, si existe el bloqueo, no tiene acceso
  }
  
}

function isNumber(val) {
  return !isNaN(val) && !isNaN(val);
}

function getMetodosPago(){
  return [
    { value:"01", descripcion: "Efectivo"},
    { value:"02", descripcion: "Cheque"},
    { value:"03", descripcion: "Transferencia"},
    { value:"04", descripcion: "Tarjetas de crédito"},
    { value:"05", descripcion: "Monederos electrónicos"},
    { value:"06", descripcion: "Dinero electrónico"},
    { value:"07", descripcion: "Tarjetas digitales"},
    { value:"08", descripcion: "Vales de despensa"},
    { value:"09", descripcion: "Bienes"},
    { value:"10", descripcion: "Servicio"},
    { value:"11", descripcion: "Por cuenta de tercero"},
    { value:"12", descripcion: "Dación en pago"},
    { value:"13", descripcion: "Pago por subrogación"},
    { value:"14", descripcion: "Pago por consignación"},
    { value:"15", descripcion: "Condonación"},
    { value:"16", descripcion: "Cancelación"},
    { value:"17", descripcion: "Compensación"},
    { value:"98", descripcion: "NA"},
    { value:"99", descripcion: "Otros"}
  ];
}

function getMesesListaWithTrece() {
  return [
    { mes: "Enero", value: "1" },
    { mes: "Febrero", value: "2" },
    { mes: "Marzo", value: "3" },
    { mes: "Abril", value: "4" },
    { mes: "Mayo", value: "5" },
    { mes: "Junio", value: "6" },
    { mes: "Julio", value: "7" },
    { mes: "Agosto", value: "8" },
    { mes: "Septiembre", value: "9" },
    { mes: "Octubre", value: "10" },
    { mes: "Noviembre", value: "11" },
    { mes: "Diciembre", value: "12" },
    { mes: "Mes Trece", value: "13" },
  ];
}

function getMesesListaWithTreceTodos() {
  return [
    { mes: "Enero", value: "1" },
    { mes: "Febrero", value: "2" },
    { mes: "Marzo", value: "3" },
    { mes: "Abril", value: "4" },
    { mes: "Mayo", value: "5" },
    { mes: "Junio", value: "6" },
    { mes: "Julio", value: "7" },
    { mes: "Agosto", value: "8" },
    { mes: "Septiembre", value: "9" },
    { mes: "Octubre", value: "10" },
    { mes: "Noviembre", value: "11" },
    { mes: "Diciembre", value: "12" },
    { mes: "Mes Trece", value: "13" },
    { mes: "<Todos>", value: "<Todos>" }
  ];
}


function getMesesOpcionTodos() {
  return [
    { mes: "Enero", value: "1" },
    { mes: "Febrero", value: "2" },
    { mes: "Marzo", value: "3" },
    { mes: "Abril", value: "4" },
    { mes: "Mayo", value: "5" },
    { mes: "Junio", value: "6" },
    { mes: "Julio", value: "7" },
    { mes: "Agosto", value: "8" },
    { mes: "Septiembre", value: "9" },
    { mes: "Octubre", value: "10" },
    { mes: "Noviembre", value: "11" },
    { mes: "Diciembre", value: "12" },
    { mes: "<Todos>", value: "<Todos>" },
  ];
}

function getMesesLista() {
  return [
    { caption: "Enero", value: "1" },
    { caption: "Febrero", value: "2" },
    { caption: "Marzo", value: "3" },
    { caption: "Abril", value: "4" },
    { caption: "Mayo", value: "5" },
    { caption: "Junio", value: "6" },
    { caption: "Julio", value: "7" },
    { caption: "Agosto", value: "8" },
    { caption: "Septiembre", value: "9" },
    { caption: "Octubre", value: "10" },
    { caption: "Noviembre", value: "11" },
    { caption: "Diciembre", value: "12" },
    { caption: "Mes Trece", value: "13" },
  ];
}

function getMesesListaNumero() {
  return [
    { caption: "1", value: "1" },
    { caption: "2", value: "2" },
    { caption: "3", value: "3" },
    { caption: "4", value: "4" },
    { caption: "5", value: "5" },
    { caption: "6", value: "6" },
    { caption: "7", value: "7" },
    { caption: "8", value: "8" },
    { caption: "9", value: "9" },
    { caption: "10", value: "10" },
    { caption: "11", value: "11" },
    { caption: "12", value: "12" },
  ];
}

function getMesConDosNumeros($Mesnumero){

  if (length($Mesnumero)==1 ){
    $Mesnumero='0'.$Mesnumero;
  }
  return $Mesnumero;
}

function getHoras() {
  return [
    { caption: "0", value: "0" },
    { caption: "1", value: "1" },
    { caption: "2", value: "2" },
    { caption: "3", value: "3" },
    { caption: "4", value: "4" },
    { caption: "5", value: "5" },
    { caption: "6", value: "6" },
    { caption: "7", value: "7" },
    { caption: "8", value: "8" },
    { caption: "9", value: "9" },
    { caption: "10", value: "10" },
    { caption: "11", value: "11" },
    { caption: "12", value: "12" },
    { caption: "13", value: "13" },
    { caption: "14", value: "14" },
    { caption: "15", value: "15" },
    { caption: "16", value: "16" },
    { caption: "17", value: "17" },
    { caption: "18", value: "18" },
    { caption: "19", value: "19" },
    { caption: "20", value: "20" },
    { caption: "21", value: "21" },
    { caption: "22", value: "22" },
    { caption: "23", value: "23" },
  ];
}

function getMinutos() {
  let minutos = [];
  //console.log(diasMes);
  for (var i = 0; i <= 59; i++) {
    //console.log(s);
    minutos.push({ caption: i.toString(), value: i.toString() });
  }
  return minutos;
}

function getAniosDownCFDI() {
  let anios = [];
  let aDate = new Date();
  const aYear = aDate.getFullYear();
  for (var i = 2011; i <= aYear; i++) {
    anios.push({ caption: i.toString(), value: i.toString() });
  }
  return anios;
}

function getNombreMes(value) {
  console.log('valor mes');
  console.log(value);
  value = value.toString();
  let mes = "Enero";
  switch (value) {
    case '1':
      mes = "Enero";
      break;
    case '2':
      mes = "Febrero";
      break;
    case '3':
      mes = "Marzo";
      break;
    case '4':
      mes = "Abril";
      break;
    case '5':
      mes = "Mayo";
      break;
    case '6':
      mes = "Junio";
      break;
    case '7':
      mes = "Julio";
      break;
    case '8':
      mes = "Agosto";
      break;
    case '9':
      mes = "Septiembre";
      break;
    case '10':
      mes = "Octubre";
      break;
    case '11':
      mes = "Noviembre";
      break;
    case '12':
      mes =  "Diciembre";
      break;
    case '13':
      mes =  "Mes Trece";
      break;
    case '14':
      mes =  "Mes Sistema";
      break;
    case '15':
      mes =  "Mes incorrecto";      
      break;
  }

  return mes;
  
}

function setFormatCurrency(value ) {

  if (!value) {
    return "0.00";
  } else {
    value = parseFloat(value).toFixed(2);
    const exp = /(\d)(?=(\d{3})+(?!\d))/g;
    const rep = "$1,";
    let arr = value.toString().split(".");
    arr[0] = arr[0].replace(exp, rep);
    return arr[1] ? arr.join(".") : arr[0];
  }
}


function formatDate(date) {
  var d = new Date(date);
  var month = "" + (d.getMonth() + 1);
  var day = "" + d.getDate();
  var year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

function getFechaIniFinMes(aYear, aMes) {
  //console.log(aYear);
  console.log('---ames---');
  console.log(aMes);
  if (aMes==="<Todos>"){
    console.log('---aqui camos con f1 y f2');
    var f1 = new Date(aYear, 0, 1); //cosa rara... pero el mes comienza de cero
    console.log(f1);
    var f2 = new Date(aYear, 11, 31);
    console.log(f2);
  
  } else {
    var diasMes = new Date(aYear, aMes, 0).getDate(); //obtenemos el numero de dias...
    console.log('diasMes');
    console.log(diasMes);
    var f1 = new Date(aYear, aMes - 1, 1);
    var f2 = new Date(aYear, aMes - 1, diasMes);
  
  }


  //console.log(f1.toISOString().split("T")[0]);
  //console.log(f2.toISOString().split("T")[0]);
  return [f1.toISOString().split("T")[0], f2.toISOString().split("T")[0]];
}

function getDiasMes(aYear, aMes) {
  var diasMes = new Date(aYear, aMes, 0).getDate();
  let dias = [];
  let sdias = "";
  //console.log(diasMes);
  for (var i = 0; i <= diasMes; i++) {
    sdias = i == 0 ? "" : i.toString();
    dias.push({ caption: sdias, value: sdias });
  }
  //console.log("dias");
  //console.log(dias);
  return dias;
}

function findWithAttr(array, attr, value) {
  for(var i = 0; i < array.length; i += 1) {
      if(array[i][attr] === value) {
          return i;
      }
  }
  return -1;
} 

function NumerosaLetras(cantidad) {

  var numero = 0;
  cantidad = parseFloat(cantidad);
  
  if (cantidad == "0.00" || cantidad == "0") {
      return "CERO PESOS CON 00/100 M.N.";
  } else {
      var ent = cantidad.toString().split(".");
      var arreglo = separar_split(ent[0]);
      var longitud = arreglo.length;
  
      switch (longitud) {
          case 1:
              numero = unidades(arreglo[0]);
              break;
          case 2:
              numero = decenas(arreglo[0], arreglo[1]);
              break;
          case 3:
              numero = centenas(arreglo[0], arreglo[1], arreglo[2]);
              break;
          case 4:
              numero = unidadesdemillar(arreglo[0], arreglo[1], arreglo[2], arreglo[3]);
              break;
          case 5:
              numero = decenasdemillar(arreglo[0], arreglo[1], arreglo[2], arreglo[3], arreglo[4]);
              break;
          case 6:
              numero = centenasdemillar(arreglo[0], arreglo[1], arreglo[2], arreglo[3], arreglo[4], arreglo[5]);
              break;
      }
  
      ent[1] = isNaN(ent[1]) ? '00' : ent[1];
      ent[1] = ent[1].length==1 ? ent[1].concat('0') : ent[1];
      
      return numero + "PESOS " + ent[1] + "/100 M.N.";
  }
  }
  
  function unidades(unidad) { var unidades = Array('UN ','DOS ','TRES ' ,'CUATRO ','CINCO ','SEIS ','SIETE ','OCHO ','NUEVE ');
  
  return unidades[unidad - 1];
  }
  
  function decenas(decena, unidad) { var diez = Array('ONCE ','DOCE ','TRECE ','CATORCE ','QUINCE' ,'DIECISEIS ','DIECISIETE ','DIECIOCHO ','DIECINUEVE '); var decenas = Array('DIEZ ','VEINTE ','TREINTA ','CUARENTA ','CINCUENTA ','SESENTA ','SETENTA ','OCHENTA ','NOVENTA ');
  
  if (decena ==0 && unidad == 0) {
      return "";
  }
  
  if (decena == 0 && unidad > 0) {
      return unidades(unidad);
  }
  
  if (decena == 1) {
      if (unidad == 0) {
          return decenas[decena -1];
      } else {
          return diez[unidad -1];
      }
  } else if (decena == 2) {
      if (unidad == 0) {
          return decenas[decena -1];
      }
      else if (unidad == 1) {
          return "VEINTI" + "UN ";
      } 
      else {
          return "VEINTI" + unidades(unidad);
      }
  } else {
  
      if (unidad == 0) {
          return decenas[decena -1] + " ";
      }
      if (unidad == 1) {
          return decenas[decena -1] + " Y " + "UNO";
      }
  
      return decenas[decena -1] + " Y " + unidades(unidad);
  }
  }
  
  function centenas(centena, decena, unidad) { var centenas = Array( "CIENTO ", "DOSCIENTOS ", "TRESCIENTOS ", "CUATROCIENTOS ","QUINIENTOS ","SEISCIENTOS ","SETECIENTOS ", "OCHOCIENTOS ","NOVECIENTOS ");
  
  if (centena == 0 && decena == 0 && unidad == 0) {
      return "";
  }
  if (centena == 1 && decena == 0 && unidad == 0) {
      return "CIEN ";
  }
  
  if (centena == 0 && decena == 0 && unidad > 0) {
      return unidades(unidad);
  }
  
  if (decena == 0 && unidad == 0) {
      return centenas[centena - 1]  +  "" ;
  }
  
  if (decena == 0) {
      var numero = centenas[centena - 1] + "" + decenas(decena, unidad);
      return numero.replace(" Y ", " ");
  }
  if (centena == 0) {
  
      return  decenas(decena, unidad);
  }
   
  return centenas[centena - 1]  +  "" + decenas(decena, unidad);
  }
  
  function unidadesdemillar(unimill, centena, decena, unidad) { var numero = unidades(unimill) + " MIL " + centenas(centena, decena, unidad); numero = numero.replace("UN MIL ", "MIL " ); if (unidad == 0) { return numero.replace(" Y ", " "); } else { return numero; } }
  
  function decenasdemillar(decemill, unimill, centena, decena, unidad) { var numero = decenas(decemill, unimill) + " MIL " + centenas(centena, decena, unidad); return numero; }
  
  function centenasdemillar(centenamill,decemill, unimill, centena, decena, unidad) {
  
  var numero = 0;
  numero = centenas(centenamill,decemill, unimill) + " MIL " + centenas(centena, decena, unidad);
  
  return numero;
  }
  
  function separar_split(texto){ var contenido = new Array(); for (var i = 0; i < texto.length; i++) { contenido[i] = texto.substr(i,1); } return contenido; }


export {
  isNumber,
  getMesesLista,
  getMesesListaWithTrece,
  getMesesListaWithTreceTodos,
  getNombreMes,
  setFormatCurrency,
  formatDate,
  getFechaIniFinMes,
  getDiasMes,
  getMesConDosNumeros,
  getHoras,
  getMinutos,
  getAniosDownCFDI,
  getMesesListaNumero,
  findWithAttr,
  NumerosaLetras,
  getMetodosPago,
  getAccess,
  getMesesOpcionTodos,

};
